import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTES } from "../../constants/routes.constants";
import Loading from "../../components/Loading";
import { getCodeLoginContext } from "../../utility/code-login-context";

const GuestNotificationLayout = () => {
  const currentUser = useSelector((state) => state.currentUser);
  const location = useLocation();
  const user = currentUser?.user;
  const codeContext = getCodeLoginContext();

  if (!currentUser || !user) {
    return <Navigate to={ROUTES.LOGIN_ROUTE} state={location} replace />;
  }

  const hasCodeContext = !!(
    user.code ||
    user.recordId ||
    user.transferRequestId ||
    codeContext?.recordId
  );
  if (!hasCodeContext) {
    return <Navigate to={ROUTES.LOGIN_ROUTE} replace />;
  }

  return (
    <div className="outer-container">
      <div className="inner-container" style={{ maxWidth: "1100px", width: "100%" }}>
        <Outlet />
        <Loading />
      </div>
    </div>
  );
};

export default GuestNotificationLayout;
